<mat-card *ngIf="values.data as data">
    <mat-card-header>
        <mat-card-title>{{data.originType | param:"projectOriginTypes"}} <ng-container *ngIf="data.originType && setting.getParamValue('projectOriginTypes', data.originType)?.info?.param">: {{data.origin | param:setting.getParamValue('projectOriginTypes',
                data.originType)?.info?.param}}</ng-container> - {{data.projectType | param:"projectTypes"}}
            Request
        </mat-card-title>
    </mat-card-header>
    <mat-list>
        <mat-list-item>
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>{{data.projectType | param:"projectTypes"}} Request</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.referral">
            <mat-icon matListIcon>{{GLOBAL.ICONS.REFERRAL}}</mat-icon>
            <h3 matLine>Referral: {{data.referral | param:"allUsers"}}</h3>
        </mat-list-item>
        <mat-list-item>
            <mat-icon matListIcon>{{GLOBAL.ICONS.CONTACT}}</mat-icon>
            <h3 matLine>
                {{data.fullname ? data.fullname : ((data.title | param:'titles') + ' ' + data.firstname + ' ' +
                data.lastname)}}
            </h3>
        </mat-list-item>
        <mat-list-item>
            <mat-icon matListIcon>{{GLOBAL.ICONS.FLAG}}</mat-icon>
            <h3 matLine>{{data.country | param:'countries'}}</h3>
        </mat-list-item>
        <mat-list-item>
            <mat-icon matListIcon>{{GLOBAL.ICONS.LANG}}</mat-icon>
            <h3 matLine>{{data.lang | param:'langs'}}</h3>
        </mat-list-item>
        <mat-list-item>
            <mat-icon matListIcon>{{GLOBAL.ICONS.PHONE}}</mat-icon>
            <h3 matLine>
                <a *ngIf="getTelLink(data.tel)" [href]="getTelLink(data.tel)">{{data.tel}}</a>
                <span *ngIf="!getTelLink(data.tel)">{{data.tel}}</span>
                <button mat-icon-button class="call-action" matTooltip="Call on phone"
                    [disabled]="callRequested"
                    (click)="requestPhoneCall(data.tel, getContactDisplayName(data))">
                    <mat-icon>phone_android</mat-icon>
                </button>
            </h3>
        </mat-list-item>
        <mat-list-item>
            <mat-icon matListIcon>{{GLOBAL.ICONS.EMAIL}}</mat-icon>
            <h3 matLine> {{data.email}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.mediumTerm">
            <mat-icon matListIcon color="warn">{{GLOBAL.ICONS.ALERT}}</mat-icon>
            <h3 matLine>Medium Term Rental (3 months)</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.inMauritius">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>In Mauritius</h3>
        </mat-list-item>
        <mat-list-item *ngIf="unitTypes.length">
            <mat-icon matListIcon *ngFor="let unitType of unitTypes">
                {{unitType | icon:'unitTypes'}}
            </mat-icon>
            <h3 matLine *ngIf="data.penthouse">Penthouse</h3>
            <h3 matLine *ngIf="data.townhouse">Townhouse</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.landType">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Land Type: {{data.landType}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.landSurface">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine> {{data.landSurface | number}} {{data.landUnit | param:'landUnits'}} </h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.bedrooms">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Bedrooms: {{data.bedrooms}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.bathrooms">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Bathrooms: {{data.bathrooms}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.InteriorSurface">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Interior Surface: {{data.InteriorSurface}} m2</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.regions">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Regions: {{data.regions}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.price">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Price: {{data.price}} {{data.priceCy | param:'cies'}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.furnished">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Furnished</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.needRefurbishment">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Ok to refurbish the property if necessary</h3>
        </mat-list-item>
        <mat-list-item *ngIf="data.firstBuyer">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>First Buyer</h3>
        </mat-list-item>

    </mat-list>
    <mat-card-content *ngIf="data.msg">
        <p>{{data.msg}}</p>
    </mat-card-content>
    <img mat-card-avatar *ngIf="values.realtor" class="top-right" [src]="values.realtor | realtor"
        [matTooltip]="values.realtor | realtorName" />
    <mat-icon mat-card-avatar *ngIf="!values.realtor" class="top-right big">
        no_accounts
    </mat-icon>
</mat-card>